import React, { useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import { APP_NAME, APP_VERSION, CANCEL_REQUEST } from "constants/index";
import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Space,
  message,
  Empty,
  Spin,
  Input,
  Layout,
} from "antd";
import { UserOutlined, KeyOutlined } from "@ant-design/icons";
import emptyImg from "../assets/img/empty.svg";
import AuthService from "services/auth.service";
import axios from "axios";

const { Header, Content, Footer } = Layout;
const { Password } = Input;
const { Meta } = Card;

const Register = (props) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleRegister = () => {
    setIsLoading(true);
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    const params = {
      username: username,
      password: password,
    };

    AuthService.register(params, source).then(
      (request) => {
        message.info("User successfully registered", 5);

        setTimeout(() => {
          setIsLoading(false);
          props.history.push("/main/");
        }, 500);
      },
      (error) => {
        if (error && error.response.data && error.response.data.errors) {
          message.error(error.response.data.errors.join(". "), 5);
        } else if (error && error.message !== CANCEL_REQUEST) {
          message.error("API got error, please contact us.", 5);
        }
        console.log(error);
        setIsLoading(false);
        return Promise.reject();
      }
    );
  };

  return (
    <>
      <main>
        <section id="login">
          <Content className="login-panel">
            <Row justify="space-around" align="middle">
              <Col span={24} offset={0}>
                <Card
                  title={APP_NAME}
                  bordered={true}
                  className="card-highlight"
                >
                  <div className="text-center">
                    <Space direction="vertical" size="middle">
                      <Input
                        placeholder="Username"
                        prefix={<UserOutlined />}
                        allowClear
                        onKeyUp={(e) => setUsername(e.target.value)}
                      />
                      <Password
                        placeholder="Password"
                        prefix={<KeyOutlined />}
                        onKeyUp={(e) => setPassword(e.target.value)}
                      />
                      {!isLoading ? (
                        <Button
                          onClick={handleRegister}
                          placement="right"
                          type="primary"
                          size="lg"
                          block
                        >
                          <span>Register</span>
                        </Button>
                      ) : (
                        <Empty
                          image={emptyImg}
                          imageStyle={{
                            height: 60,
                          }}
                          description={<span>Loading..</span>}
                        >
                          <Spin />
                        </Empty>
                      )}
                      <a href="/login" type="primary" size="lg" block>
                        Login
                      </a>
                      <Meta
                        title=""
                        description={`${APP_NAME} v${APP_VERSION} by Brian K © 2023.`}
                      />
                    </Space>
                  </div>
                </Card>
              </Col>
            </Row>
          </Content>
        </section>
      </main>
    </>
  );
};

export default Register;
